// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var decode = include.decode;

var encode = include.encode;

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_compare = include.compare;

var Id_eq = include.eq;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromString: Id_fromString,
  toString: Id_toString,
  decode: decode,
  encode: encode,
  compare: Id_compare,
  eq: Id_eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var include$1 = TypeUtils.MakeOpaqueStringType({});

var fromString = include$1.fromString;

var toString = include$1.toString;

function parse$1(param) {
  return Relude_Globals.$great$great(fromString, Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse$1,
  serialize: toString
};

var UniqueCode_decode = include$1.decode;

var UniqueCode_encode = include$1.encode;

var UniqueCode_compare = include$1.compare;

var UniqueCode_eq = include$1.eq;

var UniqueCode_Ord = include$1.Ord;

var UniqueCode_Set = include$1.$$Set;

var UniqueCode_Map = include$1.$$Map;

var UniqueCode = {
  fromString: fromString,
  toString: toString,
  decode: UniqueCode_decode,
  encode: UniqueCode_encode,
  compare: UniqueCode_compare,
  eq: UniqueCode_eq,
  Ord: UniqueCode_Ord,
  $$Set: UniqueCode_Set,
  $$Map: UniqueCode_Map,
  GraphQL_API: GraphQL_API$1
};

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* ShiftInvite */0;
    case 1 :
        return /* DayPriorConfirmation */1;
    case 2 :
        return /* DayOfConfirmation */2;
    case 3 :
        return /* ClockIn */3;
    case 4 :
        return /* ClockOut */4;
    case 5 :
        return /* RatingLeft */5;
    default:
      return ;
  }
}

function fromEnum(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 6;
  }
}

var include$2 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

var fromEnum$1 = include$2.fromEnum;

var toEnum$1 = include$2.toEnum;

var partial_arg = Curry._1(Relude_Option.flatMap, toEnum$1);

function fromString$1(param) {
  return Relude_Globals.$great$great(Relude_String.toInt, partial_arg, param);
}

function toString$1(param) {
  if (typeof param !== "number") {
    return "Unknown message type";
  }
  switch (param) {
    case /* ShiftInvite */0 :
        return "Invited to Shift";
    case /* DayPriorConfirmation */1 :
        return "Confirmed Day Prior";
    case /* DayOfConfirmation */2 :
        return "Confirmed Day Of";
    case /* ClockIn */3 :
        return "Clocked In";
    case /* ClockOut */4 :
        return "Clocked Out";
    case /* RatingLeft */5 :
        return "Left Rating";
    
  }
}

function decode$1(json) {
  return Curry._2(Json.Decode.$less$pipe$great, Curry._2(Json.Decode.variantFromInt, toEnum$1, json), Curry._2(Json.Decode.variantFromString, fromString$1, json));
}

function encode$1(param) {
  return Relude_Globals.$great$great(fromEnum$1, (function (prim) {
                return prim;
              }), param);
}

function parse$2(i) {
  return Relude_Option.getOrElse(/* FutureAddedValue */{
              _0: i
            }, Curry._1(toEnum$1, i));
}

function serialize(i) {
  if (typeof i === "number") {
    return i;
  } else {
    return i._0;
  }
}

var GraphQL_API$2 = {
  parse: parse$2,
  serialize: serialize
};

var Type_eq = include$2.eq;

var Type_compare = include$2.compare;

var Type_Ord = include$2.Ord;

var Type_compareWithConversion = include$2.compareWithConversion;

var Type_compareReversed = include$2.compareReversed;

var Type_OrdReversed = include$2.OrdReversed;

var Type_compareAsInt = include$2.compareAsInt;

var Type_min = include$2.min;

var Type_max = include$2.max;

var Type_lessThan = include$2.lessThan;

var Type_lt = include$2.lt;

var Type_lessThanOrEq = include$2.lessThanOrEq;

var Type_lte = include$2.lte;

var Type_greaterThan = include$2.greaterThan;

var Type_gt = include$2.gt;

var Type_greaterThanOrEq = include$2.greaterThanOrEq;

var Type_gte = include$2.gte;

var Type_clamp = include$2.clamp;

var Type_between = include$2.between;

var Type_OrdRingExtensions = include$2.OrdRingExtensions;

var Type_OrdNamed = include$2.OrdNamed;

var Type_OrdBy = include$2.OrdBy;

var Type_Set = include$2.$$Set;

var Type_SetWithNone = include$2.SetWithNone;

var Type_Map = include$2.$$Map;

var Type_list = include$2.list;

var Type_array = include$2.array;

var Type_set = include$2.set;

var Type_setWithNone = include$2.setWithNone;

var Type_cardinality = include$2.cardinality;

var Type_top = include$2.top;

var Type_bottom = include$2.bottom;

var Type_succ = include$2.succ;

var Type_pred = include$2.pred;

var Type = {
  fromEnum: fromEnum$1,
  toEnum: toEnum$1,
  eq: Type_eq,
  compare: Type_compare,
  Ord: Type_Ord,
  compareWithConversion: Type_compareWithConversion,
  compareReversed: Type_compareReversed,
  OrdReversed: Type_OrdReversed,
  compareAsInt: Type_compareAsInt,
  min: Type_min,
  max: Type_max,
  lessThan: Type_lessThan,
  lt: Type_lt,
  lessThanOrEq: Type_lessThanOrEq,
  lte: Type_lte,
  greaterThan: Type_greaterThan,
  gt: Type_gt,
  greaterThanOrEq: Type_greaterThanOrEq,
  gte: Type_gte,
  clamp: Type_clamp,
  between: Type_between,
  OrdRingExtensions: Type_OrdRingExtensions,
  OrdNamed: Type_OrdNamed,
  OrdBy: Type_OrdBy,
  $$Set: Type_Set,
  SetWithNone: Type_SetWithNone,
  $$Map: Type_Map,
  list: Type_list,
  array: Type_array,
  set: Type_set,
  setWithNone: Type_setWithNone,
  cardinality: Type_cardinality,
  top: Type_top,
  bottom: Type_bottom,
  succ: Type_succ,
  pred: Type_pred,
  fromString: fromString$1,
  toString: toString$1,
  decode: decode$1,
  encode: encode$1,
  GraphQL_API: GraphQL_API$2
};

exports.Id = Id;
exports.UniqueCode = UniqueCode;
exports.Type = Type;
/* include Not a pure module */
